// useToggle

import { useState } from 'react';
import { create } from 'zustand';

interface ToggleState {
  width: number;
  toggle: () => void;
  setWidth: (width: number) => void;
}

export const useToggleStore = create<ToggleState>((set) => ({
  width: window.innerWidth > 768 ? 300 : 0,
  toggle: () => set((state) => ({ width: state.width === 300 ? 0 : 300 })),
  setWidth: (width: number) => set({ width }),
}));

export const useToggle = () => {
  const [width, setWidth] = useState(300);

  const toggle = () => {
    setWidth((prev) => (prev === 300 ? 0 : 300));
  };

  return {
    width,
    toggle,
    setWidth
  } as const;
};